import { useCtaComponent } from '../../../hooks/taskCtaComponents';
import { useIsCtaRetry } from '../../../hooks/viewCta';
import { useTracker } from '../../../hooks/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
const TaskViewCardCta = ({
  config: {
    ctaId,
    href,
    text,
    retryText,
    scrollTargetSelector
  },
  'data-test-id': dataTestId,
  groupKey,
  onClick = () => {},
  size = 'small',
  use = 'tertiary-light'
}) => {
  const isRetry = useIsCtaRetry(ctaId) && !!retryText;
  const ctaText = isRetry ? retryText : text;
  const TaskViewCtaComponent = useCtaComponent(ctaId);
  const {
    trackUserInteraction
  } = useTracker();
  return /*#__PURE__*/_jsx(TaskViewCtaComponent, {
    "data-test-id": dataTestId,
    groupKey: groupKey,
    href: href,
    marginBlock: "auto",
    onClick: event => {
      onClick(event);
      trackUserInteraction('task view card cta click', ctaId, {
        groupKey
      });
    },
    scrollTarget: scrollTargetSelector,
    size: size,
    use: use,
    children: ctaText
  });
};
export default TaskViewCardCta;